module.exports = __webpack_public_path__ + "static/media/midEducIcon.21ad0b38.svg";